import { MyFiles } from "../components/dashboard/filesection";



const FilesPage = () => {
  return (
    <MyFiles/>
  );
};

export default FilesPage
